import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var FullScreen = /*#__PURE__*/function () {
  function FullScreen() {
    _classCallCheck(this, FullScreen);

    this.enable = true;
    this.zIndex = 0;
  }

  _createClass(FullScreen, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.zIndex !== undefined) {
        this.zIndex = data.zIndex;
      }
    }
  }]);

  return FullScreen;
}();